<template>
  <div class="introduction">
    <v-head></v-head>
    <div class="introduction_banner">
      {{{introduction_list}}}
      <v-footer></v-footer>
    </div>

    <!--<div class="introduction_banner">
      <img src="../../../static/images/introduction.jpg" alt="">
    </div>
    <div class="introduction_title">
      <h2>BRAND INTRODUCTION</h2>
      <p>品牌介绍</p>
    </div>
    <div class="introduction_content">
      <p>深圳市娜尔思时装有限公司（简称：娜尔思时装），由陈灵梅女士创建于1995年。 一直以来，NAERSI本着“为盛年女性装饰美丽、装扮年轻、装点自信成功的人生 ” 的经营理念，贯穿始终，坚持如一。</p>
      <p>NAERSI，专注将概念化的廓形设计与现代都市元素完美融合，引入欧式时尚与经典剪裁，致力于用年轻化、多样化的时装风格完美呈现现代都市女性自信优雅的人生态度。</p>
    </div>-->



  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          introduction_list:{}
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/273",
        data: {},
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222, data)
            _this.introduction_list = data.content;
          }
        },
      })
    }
  }
</script>

<style>
  *{font-size: 0.18rem}
  .introduction{width: 9rem;margin: 0 auto;}
  .introduction_banner{width: 9rem;margin-top: 0.5rem;font-size: 0.16rem}
  .introduction_banner img{width: 100%;height: 100%}
  .introduction_title{text-align: center;margin-top: 0.2rem;border-bottom: 0.02rem solid #000000;padding-bottom: 0.2rem}
  .introduction_title h2{font-size: 0.28rem;}
  .introduction_title p{font-size: 0.18rem;margin-top: 0.1rem}
  .introduction_content{width: 8.5rem;text-align: center;font-size: 0.16rem;line-height: 0.4rem;margin: 0 auto;padding-top: 0.2rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .introduction{width: 100%;margin: 0 auto;}
    .introduction section{ width: 100% !important}
    .introduction_banner{width: 100%;height: auto;margin-top: 0.5rem}
    .introduction_banner img{width: 100%;height: auto}
    .introduction_title{text-align: center;margin-top: 0.2rem;border-bottom: 0.02rem solid #000000;padding-bottom: 0.2rem}
    .introduction_title h2{font-size: 0.28rem;}
    .introduction_title p{font-size: 0.18rem;margin-top: 0.1rem}
    .introduction_content{width: 100%;text-align: center;font-size: 0.16rem;line-height: 0.4rem;margin: 0 auto;padding-top: 0.2rem}
  }

</style>



// WEBPACK FOOTER //
// introduction.vue?5907ea44